import { Box, Checkbox, FormControlLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { LabelCompo } from "../../../components/Comman/Label";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import DynamicReportGenerate from "../../../components/dynamicscreens/DynamicReportGenerate";
import SearchBar from "../../../components/Search";
import { withRouter } from "../../../components/withRouter";
import { blackColor, checkedColor, LightGreenColor, LightYellowColor, white, yellowishBrownColor } from "../../../config/ColorObj";
import endpoint from "../../../config/endpoints";
import {
    noInternetMsg,
    serverMsg
} from "../../../config/messageconstant";
import { ExcelReportsJson } from "../../../DynamicFormsJson/MastersJSON/excelReports";
import { SalesExecutiveJson } from "../../../DynamicFormsJson/MastersJSON/salesExecutive";
import { getSalesExecutiveAnalytics } from "../../../Slice/salesExecutive.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { downloadF } from "../../PDF/PDFDownload";
import DynamicDetails from "../../../components/dynamicscreens/DynamicDetails";

class SalesExecutiveAnalytics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {

            },
            searchValue: "",
            fromDate: "",
            toDate: "",
            salesTeamId: "",
            searchValueForAssignBeats: "",
            searchValueForDayWiseAssignBeats: "",
            searchValueForSurveyList: "",
            searchValueForFeedbackList: "",
            dataToSet: [],
        };
    }
    async componentDidMount() {
        const { getSalesExecutiveAnalytics } =
            this.props;
        if (navigator.onLine) {

            if (this.props.params.id) {

                let salesExecutiveData = JSON.parse(localStorage.getItem("salesExecutiveDetails"));

                this.setState({
                    dataToSet: [
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Name",
                            value:
                                salesExecutiveData.salesTeamName !== null
                                    ? salesExecutiveData.salesTeamName
                                    : "",
                        },

                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Region",
                            value: salesExecutiveData.regionName !== null ? salesExecutiveData.regionName : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "State",
                            value: salesExecutiveData.stateNames !== null ? salesExecutiveData.stateNames : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Zone",
                            value: salesExecutiveData.zoneNames !== null ? salesExecutiveData.zoneNames : "",
                        },

                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Area",
                            value: salesExecutiveData.areaNames !== null ? salesExecutiveData.areaNames : "",
                        },
                        {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Target Type",
                            value: salesExecutiveData.type !== null ? salesExecutiveData.type : "",
                        },
                    ],
                    fromDate: dayjs().format("DD-MM-YYYY"),
                    toDate: dayjs().format("DD-MM-YYYY"),
                    salesTeamId: this.props.params.id
                });

                showLoador({ loador: true });
                await getSalesExecutiveAnalytics({
                    fromDate: dayjs().format("DD-MM-YYYY"),
                    toDate: dayjs().format("DD-MM-YYYY"),
                    salesTeamId: this.props.params.id,
                }).then(({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                    }
                });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }



    onSearchData = async (data) => {
        const { getSalesExecutiveAnalytics, showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            this.setState({
                fromDate: data.fromDate,
                toDate: data.toDate,
                salesTeamId: this.props.params.id,
            })

            showLoador({ loador: true });
            await getSalesExecutiveAnalytics({
                fromDate: data.fromDate,
                toDate: data.toDate,
                salesTeamId: this.props.params.id,
            }).then(({ response, success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else {
                    console.log(response);
                }
            });

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };



    onSearchForAssignBeats = (searchValue) => {
        this.setState({
            searchValueForAssignBeats: searchValue,
        });
    };


    getFilteredTableDataForAssignBeats = (targetList) => {
        const { searchValueForAssignBeats } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["beatName"] &&
                    currentRow["beatName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForAssignBeats.trim().toLowerCase())) ||
                (currentRow["areaName"] &&
                    currentRow["areaName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForAssignBeats.trim().toLowerCase())) ||
                (currentRow["outletCount"] &&
                    currentRow["outletCount"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForAssignBeats.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };



    onSearchForDayWiseAssignBeats = (searchValue) => {
        this.setState({
            searchValueForDayWiseAssignBeats: searchValue,
        });
    };


    getFilteredTableDataForDayWiseAssignBeats = (targetList) => {
        const { searchValueForDayWiseAssignBeats } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["days"] &&
                    currentRow["days"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForDayWiseAssignBeats.trim().toLowerCase())) ||
                (currentRow["beatName"] &&
                    currentRow["beatName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForDayWiseAssignBeats.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };


    onSearchForSurveyList = (searchValue) => {
        this.setState({
            searchValueForSurveyList: searchValue,
        });
    };


    getFilteredTableDataForSurveyList = (targetList) => {
        const { searchValueForSurveyList } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["date"] &&
                    currentRow["date"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForSurveyList.trim().toLowerCase())) ||
                (currentRow["auditHeadName"] &&
                    currentRow["auditHeadName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForSurveyList.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };


    onSearchForFeedBack = (searchValue) => {
        this.setState({
            searchValueForFeedbackList: searchValue,
        });
    };


    getFilteredTableDataForFeedbackList = (targetList) => {
        const { searchValueForFeedbackList } = this.state;
        return targetList.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["outletName"] &&
                    currentRow["outletName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForFeedbackList.trim().toLowerCase())) ||
                (currentRow["categoryCame"] &&
                    currentRow["categoryCame"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForFeedbackList.trim().toLowerCase())) ||
                (currentRow["status"] &&
                    currentRow["status"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForFeedbackList.trim().toLowerCase())) ||
                (currentRow["remark"] &&
                    currentRow["remark"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValueForFeedbackList.trim().toLowerCase()))
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    rowDataForExcelReports = [
        {
            isStatic: true,
            index: 1,
            reportName: "Login Summary Report",
            filter:
                "",
            url: "/api/distributionreport/v1//monthly-sales-analysis/by-dates-and-stock-stake-holder",
            days: 124,
        },
        {
            isStatic: true,
            index: 2,
            reportName: "Allowance Wise Report",
            filter: "",
            url: "/api/distributionreport/v1/monthly-sale-bill-analysis/new?fromDate={fromDate}&toDate={toDate}&distributorId={stockStakeHolder}",
            days: 124,
        },
        {
            isStatic: true,
            index: 3,
            reportName:
                "Consolidate report",
            filter:
                "",
            url: "/api/distributionreport/v1/report/product-sale-register?fromDate={fromDate}&toDate={toDate}",
            days: 31,
        },
        {
            isStatic: true,
            index: 4,
            reportName:
                "Sales Team Attendance Summary Report",
            filter:
                "",
            url: "/api/distributionreport/v1/report/product-sale-register?fromDate={fromDate}&toDate={toDate}",
            days: 31,
        },
        {
            isStatic: true,
            index: 5,
            reportName:
                "Sales Team Attendance Detailed Report",
            filter:
                "",
            url: "/api/distributionreport/v1/report/product-sale-register?fromDate={fromDate}&toDate={toDate}",
            days: 31,
        }
    ];


    getExcel = (row, rowData) => {
        const { fromDate, toDate, salesTeamId } = this.state;
        const { showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            const [fromDay, fromMonth, fromYear] = fromDate.split('-');
            const formattedFromDate = `${fromDay}-${fromMonth.padStart(2, '0')}-${fromYear}`;

            const [toDay, toMonth, toYear] = toDate.split('-');
            const formattedToDate = `${toDay}-${toMonth.padStart(2, '0')}-${toYear}`;

            if (rowData.index == 1) {

                showLoador({ loador: true });
                downloadF({
                    isGet: true,
                    url: endpoint.salesExecutive + "/monthly-check-in-out-excel-report?fromDate="
                        + formattedFromDate + "&toDate=" + formattedToDate + "&salesTeamId=" + salesTeamId,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 2) {

                showLoador({ loador: true });
                downloadF({
                    isGet: true,
                    url: endpoint.salesExecutive + "/monthly-travel-and-daily-claim-excel-report?fromDate="
                        + formattedFromDate + "&toDate=" + formattedToDate + "&salesTeamId=" + salesTeamId,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 3) {
                showLoador({ loador: true });
                downloadF({
                    isGet: true,
                    url: endpoint.salesExecutive + "/monthly-order-claim-excel-report?fromDate="
                        + formattedFromDate + "&toDate=" + formattedToDate + "&salesTeamId=" + salesTeamId,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 4) {
                const dataToSave = {
                    fromDate: formattedFromDate,
                    toDate: formattedToDate,
                    salesTeamId: salesTeamId,

                };

                showLoador({ loador: true });
                downloadF({
                    isGet: false,
                    url: endpoint.reportForExcelReportsLatest + "/get-sales-team-attendence-summary-report-excel",
                    postBody: dataToSave,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            } else if (rowData.index == 5) {
                const dataToSave = {
                    fromDate: formattedFromDate,
                    toDate: formattedToDate,
                    salesTeamId: salesTeamId,

                };

                showLoador({ loador: true });
                downloadF({
                    isGet: false,
                    url: endpoint.reportForExcelReportsLatest + "/get-sales-team-attendence-detailed-report-excel",
                    postBody: dataToSave,
                    ext: "xls",
                    openNewTab: false,
                }).then((response) => {
                    if (!response) {
                        showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    }
                    showLoador({ loador: false });
                });
            }


        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    render() {
        const { salesExecutiveList } = this.props;
        const {
            dynamicMasterData,
            searchValueForAssignBeats,
            searchValueForDayWiseAssignBeats,
            searchValueForSurveyList,
            searchValueForFeedbackList,
            dataToSet,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 2,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        DataToSet={dataToSet}
                        showBackToList={true}
                        dynamicMasterData={dynamicMasterData}
                        showTitle={true}
                        screenTitle={SalesExecutiveJson.screenTitleForAnalytics}
                        fieldMeta={SalesExecutiveJson.fieldMetaForAnalytics}
                        showSaveBtnMain={false}
                        showSaveNextBtn={false}
                        showSaveBtn={true}
                        saveBtnText={"Search"}
                        onSave={this.onSearchData}
                        padding={true}
                        paddingTop={true}
                    />
                    <br />

                    {Object.keys(salesExecutiveList?.salesExecutiveAnalysis).length !== 0 && (
                        <>

                            <div
                                style={{
                                    display: "flex",
                                    gap: 15,
                                    width: "100%",
                                    padding: 15,
                                    minHeight: "100vh",
                                }}
                            >
                                {/* Left Column for Cards & Tables */}
                                <div style={{
                                    flex: 3,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 15,
                                    width: "70px"
                                }}>
                                    {/* Row 1 for Card 1, Card 2 & Card 3  */}
                                    <div style={{ display: "flex", flexDirection: "row", gap: 15, width: "100%" }}>
                                        {/* Card 1 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Center the value horizontally
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "17px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.checkInCount}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Center the text horizontally
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                CHECK-IN
                                            </div>
                                        </div>

                                        {/* Card 2 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Center the value horizontally
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "17px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.totalVisiteOutletCount}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Center the text horizontally
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                TOTAL VISITED OUTLET
                                            </div>
                                        </div>

                                        {/* Card 3 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Center the value horizontally
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "17px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.productiveCount}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Center the text horizontally
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                PRODUCTIVE COUNT
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 2 for Card 4, Card 5 & Card 6  */}
                                    <div style={{ display: "flex", flexDirection: "row", gap: 15, width: "100%", marginTop: 15 }}>
                                        {/* Card 4 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Center the value horizontally
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "17px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.orderAmt.toFixed(2)}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Center the text horizontally
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                ORDER AMOUNT
                                            </div>
                                        </div>

                                        {/* Card 5 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Already centered
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "17px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.taDaAmt.toFixed(2)}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Already centered
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                TA/DA AMOUNT
                                            </div>
                                        </div>

                                        {/* Card 6 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Center the value horizontally
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "15px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.Target.toFixed(2)}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Center the text horizontally
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                TARGET
                                            </div>
                                        </div>

                                        {/* Card 7 */}
                                        <div
                                            style={{
                                                backgroundColor: "white",
                                                flex: 1, // Equal width for both cards
                                                borderRadius: "3%",
                                                padding: "12px",
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center", // Center the value horizontally
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontSize: "17px", fontWeight: "500" }}>
                                                    {salesExecutiveList?.salesExecutiveAnalysis.Achievement.toFixed(2)}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "lightgray",
                                                    height: "1px",
                                                    width: "100%",
                                                }}
                                            ></div>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center", // Center the text horizontally
                                                    padding: "8px 0",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                ACHIEVEMENT
                                            </div>
                                        </div>
                                    </div>

                                    {/* Beat Assign Table */}
                                    <div
                                        style={{
                                            background: "white",
                                            padding: 5,
                                            borderRadius: 8,
                                            border: "1px #E6E6E6 solid",
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: "white",
                                                borderRadius: 8,
                                                border: "0 #E6E6E6 solid",
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: "white",
                                                    borderRadius: 8,
                                                    border: "0 #E6E6E6 solid",
                                                    overflow: "scroll",
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Assigned Beat List
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ "aria-label": "search" }}
                                                            searchValueForAssignBeats={searchValueForAssignBeats}
                                                            filteredRows={this.onSearchForAssignBeats}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: "#fff" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: "2%" }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "8%" }}>
                                                            Beat Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "5%" }}>
                                                            Area Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "5%" }}>
                                                            Outlet Count
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                    {salesExecutiveList?.salesExecutiveAnalysis?.beatAssign.length !== 0 ?
                                                        (<>
                                                            {this.getFilteredTableDataForAssignBeats(salesExecutiveList?.salesExecutiveAnalysis?.beatAssign)?.map((beatAssignObj, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center">{index + 1}</TableCell>
                                                                    <TableCell align="left">{beatAssignObj.beatName}</TableCell>
                                                                    <TableCell align="left">{beatAssignObj.areaName}</TableCell>
                                                                    <TableCell align="center">{beatAssignObj.outletCount}</TableCell>
                                                                </TableRow>
                                                            ))}

                                                        </>) : (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                        No data found
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>

                                                        )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>

                                    {/*   Day-Wise Assigned Beat Table */}
                                    <div
                                        style={{
                                            background: "white",
                                            padding: 5,
                                            borderRadius: 8,
                                            border: "1px #E6E6E6 solid",
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: "white",
                                                borderRadius: 8,
                                                border: "0 #E6E6E6 solid",
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: "white",
                                                    borderRadius: 8,
                                                    border: "0 #E6E6E6 solid",
                                                    overflow: "scroll",
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Day-Wise Assigned Beat List
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ "aria-label": "search" }}
                                                            searchValueForDayWiseAssignBeats={searchValueForDayWiseAssignBeats}
                                                            filteredRows={this.onSearchForDayWiseAssignBeats}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: "#fff" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: "2%" }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "18%" }}>
                                                            Day
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "80%" }}>
                                                            Beat Name
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {salesExecutiveList?.salesExecutiveAnalysis?.dayWiseBeatAssign.length !== 0 ?
                                                        (
                                                            <>
                                                                {this.getFilteredTableDataForDayWiseAssignBeats(salesExecutiveList?.salesExecutiveAnalysis?.dayWiseBeatAssign)?.map((billDataObj, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="center">{index + 1}</TableCell>
                                                                        <TableCell align="left">{billDataObj.days}</TableCell>
                                                                        <TableCell align="left">{billDataObj.beatName}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </>
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                        No data found
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>


                                    {/*Roaster Table */}
                                    <div
                                        style={{
                                            background: "white",
                                            padding: 5,
                                            borderRadius: 8,
                                            border: "1px #E6E6E6 solid",
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: "white",
                                                borderRadius: 8,
                                                border: "0 #E6E6E6 solid",
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: "white",
                                                    borderRadius: 8,
                                                    border: "0 #E6E6E6 solid",
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Beat Projection
                                                </h4>
                                            </div>
                                        </div>

                                        <>
                                            <FormControlLabel
                                                value="end"
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: checkedColor,
                                                            "&.Mui-checked": { color: checkedColor },
                                                        }}
                                                        checked={true}
                                                    />
                                                }
                                                label="Absent"
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="end"
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: yellowishBrownColor,
                                                            "&.Mui-checked": { color: yellowishBrownColor },
                                                        }}
                                                        checked={true}
                                                    />
                                                }
                                                label="Previous"
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="end"
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: LightYellowColor,
                                                            "&.Mui-checked": { color: LightYellowColor },
                                                        }}
                                                        checked={true}
                                                    />
                                                }
                                                label="Day wise record"
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="end"
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: LightGreenColor,
                                                            "&.Mui-checked": { color: LightGreenColor },
                                                        }}
                                                        checked={true}
                                                    />
                                                }
                                                label="Date wise record"
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="end"
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: blackColor,
                                                            "&.Mui-checked": { color: blackColor },
                                                        }}
                                                        checked={false}
                                                    />
                                                }
                                                label="Not assigned any beat"
                                                labelPlacement="end"
                                            />

                                            <br />
                                            <div style={{ overflowX: "auto", width: "100%" }}>
                                                <TableContainer>
                                                    <Table
                                                        aria-label="simple table"
                                                        size="medium"
                                                        style={{ minWidth: "100px", tableLayout: "auto" }}
                                                    >
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                                                    Sr. No.
                                                                </TableCell>
                                                                <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                                                    Name
                                                                </TableCell>
                                                                {salesExecutiveList?.salesExecutiveAnalysis?.projectionDates.map((data, index) => (
                                                                    <TableCell
                                                                        align="center"
                                                                        style={{ minWidth: "100px", whiteSpace: "nowrap" }}
                                                                        key={index}
                                                                    >
                                                                        {data.dates} {data.weekDay}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {salesExecutiveList?.salesExecutiveAnalysis?.projectionPersons.map((matrixDataRow, indexRow) => (
                                                                <TableRow key={indexRow}>
                                                                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                                                        {indexRow + 1}
                                                                    </TableCell>
                                                                    <TableCell style={{ whiteSpace: "nowrap" }}>
                                                                        {matrixDataRow.salesTeamName +
                                                                            " (" +
                                                                            matrixDataRow.salesTeamStockHolderTypePrefix +
                                                                            ")"}
                                                                    </TableCell>
                                                                    {salesExecutiveList?.salesExecutiveAnalysis?.projectionDates.map((columnName, index) => {
                                                                        const newDayData = salesExecutiveList?.salesExecutiveAnalysis?.projectionPersonAndDateList.find(
                                                                            (item) =>
                                                                                item.date === columnName.dates &&
                                                                                item.salesTeamId === matrixDataRow.salesTeamId
                                                                        );

                                                                        return (
                                                                            <TableCell
                                                                                key={index}
                                                                                sx={{
                                                                                    height: 100,
                                                                                    background:
                                                                                        newDayData
                                                                                            ? newDayData.flag === "0" && newDayData.beatNames === "AB"
                                                                                                ? checkedColor
                                                                                                : newDayData.flag === "0"
                                                                                                    ? yellowishBrownColor
                                                                                                    : newDayData.flag === "1"
                                                                                                        ? LightGreenColor
                                                                                                        : newDayData.flag === "2"
                                                                                                            ? LightYellowColor
                                                                                                            : white
                                                                                            : white,
                                                                                    cursor: "pointer",
                                                                                    whiteSpace: "nowrap",
                                                                                }}
                                                                            >
                                                                                <LabelCompo
                                                                                    className="text-black"
                                                                                    style={{ fontSize: 12 }}
                                                                                    label={newDayData ? newDayData.beatNames : ""}
                                                                                />
                                                                            </TableCell>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>

                                        </>
                                    </div>


                                    {/* Survey Table */}
                                    <div
                                        style={{
                                            background: "white",
                                            padding: 5,
                                            borderRadius: 8,
                                            border: "1px #E6E6E6 solid",
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: "white",
                                                borderRadius: 8,
                                                border: "0 #E6E6E6 solid",
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: "white",
                                                    borderRadius: 8,
                                                    border: "0 #E6E6E6 solid",
                                                    overflow: "scroll",
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Survey
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ "aria-label": "search" }}
                                                            searchValueForSurveyList={searchValueForSurveyList}
                                                            filteredRows={this.onSearchForSurveyList}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: "#fff" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: "5%" }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "30%" }}>
                                                            Date
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "65%" }}>
                                                            Survey Name
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {salesExecutiveList?.salesExecutiveAnalysis?.auditTransaction.length !== 0 ?
                                                        (
                                                            <>
                                                                {this.getFilteredTableDataForSurveyList(salesExecutiveList?.salesExecutiveAnalysis?.auditTransaction)?.map((billDataObj, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="center">{index + 1}</TableCell>
                                                                        <TableCell align="center">{billDataObj.date}</TableCell>
                                                                        <TableCell align="left">{billDataObj.auditHeadName}</TableCell>
                                                                    </TableRow>
                                                                ))}

                                                            </>
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                        No data found
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>

                                    {/* Feedback Table */}
                                    <div
                                        style={{
                                            background: "white",
                                            padding: 5,
                                            borderRadius: 8,
                                            border: "1px #E6E6E6 solid",
                                        }}
                                    >
                                        <div
                                            style={{
                                                marginBottom: -2,
                                                background: "white",
                                                borderRadius: 8,
                                                border: "0 #E6E6E6 solid",
                                            }}
                                        >
                                            <div
                                                className="card-header align-items-center d-flex"
                                                style={{
                                                    background: "white",
                                                    borderRadius: 8,
                                                    border: "0 #E6E6E6 solid",
                                                    overflow: "scroll",
                                                }}
                                            >
                                                <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                                                    Feedback
                                                    <div style={{ marginTop: 8, marginLeft: -25 }}>
                                                        <SearchBar
                                                            placeHolder="Search..."
                                                            inputProps={{ "aria-label": "search" }}
                                                            searchValueForAssignBeats={searchValueForFeedbackList}
                                                            filteredRows={this.onSearchForFeedBack}
                                                        />
                                                    </div>
                                                </h4>
                                            </div>
                                        </div>
                                        <TableContainer sx={{ maxHeight: 440, marginTop: 0 }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead style={{ backgroundColor: "#fff" }}>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: "5%" }}>
                                                            Sr.No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "15%" }}>
                                                            Outlet Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "15%" }}>
                                                            Category Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "20%" }}>
                                                            status
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "30%" }}>
                                                            remark
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {salesExecutiveList?.salesExecutiveAnalysis?.feedBackList.length !== 0 ?
                                                        (
                                                            <>
                                                                {this.getFilteredTableDataForFeedbackList(salesExecutiveList?.salesExecutiveAnalysis?.feedBackList)?.map((billDataObj, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell align="center">{index + 1}</TableCell>
                                                                        <TableCell align="left">{billDataObj.outletName}</TableCell>
                                                                        <TableCell align="left">{billDataObj.categoryCame}</TableCell>
                                                                        <TableCell align="center">{billDataObj.status}</TableCell>
                                                                        <TableCell align="left">{billDataObj.remark}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </>
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={7} align="center">
                                                                    <Typography variant="h7" color="textSecondary" sx={{ whiteSpace: 'nowrap' }}>
                                                                        No data found
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>

                                {/* Right Column for Timeline (Unchanged) */}
                                <div style={{
                                    flex: 1,
                                    minWidth: '300px', // Adjusted container width
                                    padding: '12px'
                                }}>
                                    <div style={{
                                        position: 'sticky',
                                        top: 15,
                                        maxHeight: 'calc(100vh - 30px)',
                                        background: 'white',
                                        padding: '12px',
                                        borderRadius: 10,
                                        border: '1px solid #E6E6E6',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}>
                                        <h4 style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            zIndex: 10,
                                            padding: '8px 0',
                                            borderBottom: '1px solid #E6E6E6',
                                            margin: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#333',
                                        }}>
                                            Time Line
                                        </h4>
                                        <div style={{
                                            flex: 1,
                                            overflowY: 'auto',
                                            marginTop: '16px',
                                        }}>
                                            {salesExecutiveList?.salesExecutiveAnalysis?.timeLine?.map(
                                                (timeLineOj, index) => {
                                                    const itemObject = {
                                                        id: timeLineOj.id,
                                                        date: timeLineOj.date,
                                                        orderAmt: timeLineOj.orderAmt,
                                                        billAmt: timeLineOj.billAmt,
                                                    };
                                                    return (
                                                        <div key={index} style={cardStyle}>
                                                            <div style={headerStyle}>Date: {itemObject.date}</div>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                padding: '8px',
                                                                gap: '16px', // Adjusted gap for better spacing
                                                                justifyContent: 'space-between' // Ensures even spacing
                                                            }}>
                                                                <div style={dataSectionStyle}>
                                                                    <span style={{
                                                                        fontSize: '13px',
                                                                        fontWeight: '600',
                                                                        color: '#2c3e50'
                                                                    }}>
                                                                        {itemObject.orderAmt.toFixed(2)}
                                                                    </span>
                                                                    <span style={{
                                                                        fontSize: '13px',
                                                                        fontWeight: '500',
                                                                        color: '#666'
                                                                    }}>
                                                                        Order Amount
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <DynamicReportGenerate
                                maxDateValid={true}
                                getExcel={this.getExcel}
                                screenTitle={ExcelReportsJson.screenTitle}
                                fieldMeta={[]}
                                buttonCenter={ExcelReportsJson.buttonCenter}
                                dynamicMasterData={dynamicMasterData}
                                searchButton={false}
                                PDFButton={false}
                                EXCELButton={false}
                                baseIdColumn={ExcelReportsJson.baseIdColumn}
                                apiBaseURL={ExcelReportsJson.apiBaseURL}
                                marginTop={false}
                                openNewTab={true}
                                rowData={this.rowDataForExcelReports}
                                hideNoteAndResetButton={true}
                            />
                        </>
                    )}
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesExecutiveList: state.salesExecutive,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getSalesExecutiveAnalytics,


};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(SalesExecutiveAnalytics);


const cardStyle = {
    background: '#fff',
    borderRadius: '10px',
    border: '1px solid #E6E6E6',
    marginBottom: '16px',
    overflow: 'hidden',
    padding: '8px',
    width: '100%',
    maxWidth: '350px', // Reduced card width
    minHeight: '100px', // Reduced card height
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
};

const headerStyle = {
    background: '#f8f8f8',
    padding: '8px',
    fontSize: '14px',
    fontWeight: '600',
    borderBottom: '1px solid #E6E6E6',
    borderRadius: '6px 6px 0 0',
    color: '#333',
};

const dataSectionStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    padding: '8px',
    gap: '4px', // Reduced gap for tighter spacing
};

